import axios from "axios"; //引入
import { Dialog } from "vant";
import router from "@/router";

export const api = axios.create({
  baseURL: "https://api.9163.cam",
  timeout: 30000, //设置最大请求时间
});

/* 请求拦截器（请求之前的操作） */
api.interceptors.request.use(
  (config) => {
    //如果有需要在这里开启请求时的loading动画效果
    // Authorization:Bearer hPxf6a8TQnCkExTYxceujYgXoW9GXB9909zsZtpvabw6yO9ngcMVKgLx4mzD
    let token = sessionStorage.getItem("token")
      ? sessionStorage.getItem("token")
      : "";
    config.headers.Authorization = "Bearer " + token; //添加token,需要结合自己的实际情况添加，
    return config;
  },
  (err) => Promise.reject(err)
);

/* 请求之后的操作 */
api.interceptors.response.use(
  (res) => {
    //在这里关闭请求时的loading动画效果
    //这里用于处理返回的结果，比如如果是返回401无权限，可能会是跳回到登录页的操作，结合自己的业务逻辑写

    if (res.data.code === 401) {
      const currentPath = router.currentRoute.path;
      const token = sessionStorage.getItem('token');
      const isAuthPage = ['/login', '/register'].includes(currentPath);

      localStorage.clear();
      sessionStorage.clear();

      if (!token || isAuthPage) {
        return res;
      }

      Dialog.alert({
        title: "认证失败",
        message: "您的账号登陆过期，请重新登陆",
      }).then(() => {
        router.replace("/login");
      });
    }
    return res;
  },
  (err) => {
    if (err) {
      //在这里关闭请求时的loading动画效果
      // Toast("请求网络失败")
    }
    return Promise.reject(err);
  }
);

//封装post,get方法
const http = {
  get(url = "", params = {}) {
    return new Promise((resolve, reject) => {
      // 'Content-Type': 'application/json'
      api({
        url,
        params,
        headers: { "Content-Type": "application/json;charset=UTF-8" },
        method: "GET",
      })
        .then((res) => {
          resolve(res.data);
          return res;
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  post(url = "", params = {}) {
    return new Promise((resolve, reject) => {
      api({
        url,
        data: params,
        headers: { "Content-Type": "application/json;charset=UTF-8" },
        method: "POST",
      })
        .then((res) => {
          resolve(res.data);
          return res;
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default http;
